import React, { useState } from "react";
import { markdown } from "markdown";

import PortfolioItem from "./portfolioItem";

const createAudio = url => {
  try {
    const audioElement = document.createElement("audio");
    audioElement.setAttribute("src", url);
    return audioElement;
  } catch (e) {
    return {
      play: () => {},
      pause: () => {}
    };
  }
};

const getOnClick = (url, type, element) => {
  if (type === "Audio") {
    const audio = createAudio(url);
    return isPlaying => {
      if (isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
    };
  }
  return null;
};

export default ({
  name,
  type,
  portfolioItem: {
    file: { url }
  },
  coverImage
}) => {
  const backgroundImage = type === "Photo" ? url : coverImage.file.url;
  const videoLink = type === "Video" ? url : null;

  const onClick = getOnClick(url, type);

  return (
    <div className="col-md-6">
      <PortfolioItem
        name={name}
        type={type}
        backgroundImage={backgroundImage}
        onClick={onClick}
        videoLink={videoLink}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/portfolioItemFrame.js